import React from 'react';

function Properties() {
  const properties = [
    {
      title: 'مشاريع عقارية فاخرة',
      description: 'مشاريع سكنية وتجارية حديثة',
      image: '/images/property1.png',
      category: 'مشاريع'
    },
    {
      title: 'عمارات سكنية',
      description: 'عمارات حديثة في مواقع مميزة',
      image: '/images/property2.png',
      category: 'عمارات'
    },
    {
      title: 'مشاريع عالمية',
      description: 'مشاريع عقارية في أرقى المناطق',
      image: '/images/property3.png',
      category: 'مشاريع عالمية'
    },
    {
      title: 'أراضي زراعية',
      description: 'أراضي زراعية خصبة للاستثمار',
      image: '/images/property4.png',
      category: 'أراضي'
    }
  ];

  return (
    <section id="properties" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-awa-dark mb-4">
            أنواع العقارات على <span className="text-awa-green">AWA</span>
          </h2>
          <p className="text-lg text-awa-gray max-w-2xl mx-auto">
            من الشقق السكنية إلى الأراضي الزراعية، نوفر لك جميع أنواع العقارات
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {properties.map((property, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg overflow-hidden transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4">
                  <span className="bg-awa-green text-white px-4 py-2 rounded-full text-sm font-bold">
                    {property.category}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-awa-dark mb-2 group-hover:text-awa-green transition-colors">
                  {property.title}
                </h3>
                <p className="text-awa-gray text-sm">
                  {property.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 gradient-bg rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">
            لديك عقار؟ انشره الآن!
          </h3>
          <p className="text-lg mb-8 opacity-90">
            انضم إلى آلاف المالكين الذين يستخدمون AWA للوصول إلى ملايين المشترين
          </p>
          <button
            onClick={() => document.getElementById('download').scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-awa-green px-8 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
          >
            ابدأ الآن مجاناً
          </button>
        </div>
      </div>
    </section>
  );
}

export default Properties;
